<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// 定义屏幕宽度阈值常量
const SCREEN_WIDTH_THRESHOLD = 1010;

export default {
  data() {
    return {
      browserWidth: window.innerWidth,
    };
  },
  mounted() {
    // 初始化刷新状态
    this.setInitialRefreshStates();
    // 添加窗口大小变化监听
    window.addEventListener("resize", this.handleResize);
    // 初始检查宽度
    this.checkScreenWidthAndRefresh();
  },
  beforeUnmount() {
    // 移除事件监听，防止内存泄漏
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    /**
     * 初始化本地存储中的刷新状态
     */
    setInitialRefreshStates() {
      localStorage.setItem("PChasRefreshed", "1");
      localStorage.setItem("MobilehasRefreshed", "1");
    },

    /**
     * 处理窗口大小变化事件
     */
    handleResize() {
      this.checkScreenWidthAndRefresh();
    },

    /**
     * 检查屏幕宽度并决定是否需要刷新页面
     */
    checkScreenWidthAndRefresh() {
      const currentWidth = window.innerWidth;
      const isMobileScreen = currentWidth < SCREEN_WIDTH_THRESHOLD;
      const pcRefreshed = localStorage.getItem("PChasRefreshed");
      const mobileRefreshed = localStorage.getItem("MobilehasRefreshed");

      // 更新当前浏览器宽度
      this.browserWidth = currentWidth;

      // 根据屏幕宽度和刷新状态决定是否刷新
      if (isMobileScreen) {
        console.log("宽度小于", SCREEN_WIDTH_THRESHOLD, "px，检查是否需要刷新");
        console.log("移动端已刷新状态:", mobileRefreshed);

        if (mobileRefreshed !== "1") {
          window.location.reload();
        } else {
          // 标记PC端未刷新
          localStorage.setItem("PChasRefreshed", "0");
        }
      } else {
        if (pcRefreshed !== "1") {
          window.location.reload();
        } else {
          // 标记移动端未刷新
          localStorage.setItem("MobilehasRefreshed", "0");
        }
      }
    },
  },
};
</script>

<style scoped>
#app {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
